var render = function () {
var this$1 = this;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"templete_box"},[_c('navTab',{attrs:{"navlist":_vm.navlist,"nav-index":_vm.tab,"templateName":'bankingPayableRedeemList'},on:{"reback":function (res){this$1.tab = res;}}}),(Number(_vm.tab) === 0)?_c('lookCargo',{on:{"child-num":_vm.emitNum}}):_vm._e(),(Number(_vm.tab) === 1)?_c('cargoFlow',{on:{"child-num":_vm.emitNum}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }